import { MuiIcons } from "@osu/react-ui";

export default function EasyCopy({ contents }) {
    if (process.env.REACT_APP_SWAT_ENABLE_EZCOPY !== "true") { return <></>; }
    
    const style = {
        fontSize: 14,
        cursor: "pointer",
        marginRight: "0.5rem"
    };
    
    function copyContents() { navigator.clipboard.writeText(contents); }
    
    return <MuiIcons.ContentCopy onClick={copyContents} sx={style} />;
}